import { useFirestoreGeneral } from '../../firebase/useFirestore'
import { Fragment } from 'react';

const PersonaMeta = ({personaId}) => {

  const personas = useFirestoreGeneral('Personas', 'ID', personaId ? personaId : '')

  return (
    <>
        {personas && personas.map(persona => (
           <Fragment key={persona.ID}>
              {persona.Name}
          </Fragment>
        ))}
    </>
  )
}

export default PersonaMeta